import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import {
  LoadingController,
  Platform,
  AlertController,
  MenuController,
  ModalController,
} from "@ionic/angular";
import { loadingProps } from "src/utils/util.functions";
import { RaceService } from "src/app/services/race.service";
import {
  User,
  EnterInLineViewModel,
  ResponseAPI,
} from "../../../models/user.model";
import { CrudService } from "../../services/crud.service";
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  Event,
} from "@angular/router";
import { UtilService } from "../../services/util.service";
import { SignalRService } from "src/app/services/signalr.service";
import { Balance } from "src/app/caller/balance-driver/balance-driver.page";
import { AuthService } from "src/app/services/auth.service";
import { StatusBar } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";
import { Events } from "src/app/services/events-service.service";
import { StatusCorrida } from "src/models/reserva.model";
import { OneSignalService } from "../../services/oneSignal.service";
import { HubConnectionState } from "@microsoft/signalr";
import { lastValueFrom, filter } from "rxjs";
import { PaymentService } from "../../services/payment.service";
import { PaymentCompleteComponent } from "../payment-complete/payment-complete.component";
import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";

@Component({
    selector: "app-queue-driver",
    templateUrl: "./queue-driver.page.html",
    styleUrls: ["./queue-driver.page.scss"],
    providers: [],
    standalone: false
})
export class QueueDriverPage implements OnInit {
  isWaiting = false;
  secondsToAccept = 30;
  user: User;
  balance: Balance = {
    saldoTotal: 0,
    saldoEmAberto: 0,
    saldoRecebido: 0,
    saldoDiario: 0,
    saldoSemanal: 0,
    saldoBonus: 0,
    saldoBonusDia: 0,
    saldoGanhoDiarioMotorista: 0,
    saldoGanhoSemanalMotorista: 0,
    saldoGanhoAnualMotorista: 0,
    saldoBonusSemanal: 0,
    saldoBonusAnual: 0,
    terminoData: new Date(),
  };
  raceInfo = {
    numeroCarrosFila: 0,
    posicaoMotoristaFila: 0,
    numerosCorridaDia: 0,
  };
  enterInLineViewModel = {} as EnterInLineViewModel;
  interval: NodeJS.Timeout;
  disputedTripsCount = 0;
  constructor(
    private loadingCtrl: LoadingController,
    private raceService: RaceService,
    public router: Router,
    private route: ActivatedRoute,
    private auth: AuthService,
    private crudService: CrudService,
    private platform: Platform,
    public alertController: AlertController,
    private signalRService: SignalRService,
    private util: UtilService,
    private _event: Events,
    private menuCtrl: MenuController,
    private oneSignalService: OneSignalService,
    private paymentService: PaymentService,
    private modalCtrl: ModalController
  ) {
    this.user = this.auth.user;
  }

  ngOnInit() {
    if (Capacitor.isNativePlatform()) {
      StatusBar.hide().catch(() => {});
      SplashScreen.hide().catch(() => {});
    }
    this.router.events.subscribe(async (event: Event) => {
      if (event instanceof NavigationStart) {
        console.log("navigation start", event);
      }

      if (event instanceof NavigationEnd) {
        console.log("navigation end", event);

        if (event.url.includes("/driver/queue?payment=success")) {
          while (await this.modalCtrl.getTop()) {
            await this.modalCtrl.dismiss();
          }
          const modal = await this.modalCtrl.create({
            component: PaymentCompleteComponent,
          });
          modal.onDidDismiss().then(async () => {
            const result = await (
              await this.raceService.getBalance()
            ).toPromise();
            this.balance = result.data;
          });
          await modal.present();
        }
      }

      if (event instanceof NavigationError) {
        console.log("navigation error", event);
      }
    });
  }

  async ionViewWillEnter() {
    this.clearStorage();
    this.menuCtrl.enable(true);
    this._event.subscribe("clearQueueInterval", () => {
      this.clearQueueInterval();
    });
    this._event.subscribe("getBalance", async () => {
      const result = await (await this.raceService.getBalance()).toPromise();
      this.balance = result.data;
    });
    this.showBatteryInfo();
    this.getInfo();
    const result = await (await this.raceService.getBalance()).toPromise();
    this.balance = result.data;
    this.enterInLineViewModel.driverId = this.user.id;
    await this.signalRService.disconnect();
    this.signalRService.clearHub();
    await this.signalRService.setUpConnection(this.enterInLineViewModel);
    this._event.publish("enableScheduledCalls");
    this.enterInLineViewModel.acceptedRace = false;
    await this.signalRService.setDriverConnectOnly(this.enterInLineViewModel);
    this.pendingTrip();
    await this.disputedTrips();
    const response = await lastValueFrom<any>(
      this.crudService.getData("motorista/is-online")
    );
    console.log(response);
    if (response.success && response.data) {
      await this.router.navigate(["driver", "information-queue"]);
      if (Capacitor.isNativePlatform()) {
        StatusBar.hide().catch(() => {});
        SplashScreen.hide().catch(() => {});
      }
    }
    if (Capacitor.isNativePlatform()) {
      StatusBar.hide().catch(() => {});
      SplashScreen.hide().catch(() => {});
    }
  }

  private clearStorage() {
    localStorage.removeItem("currentRace");
    localStorage.removeItem("acceptRace");
    localStorage.removeItem("raceRequest");
    localStorage.removeItem("enterInLine");
    sessionStorage.removeItem("paramIdVendedor");
    sessionStorage.removeItem("dataClient");
  }

  private showBatteryInfo() {
    if (Capacitor.isNativePlatform()) {
      this.oneSignalService.requestPermissionAndEnableOneSignal();
      // Battery optimization prompt - open native settings via Browser
      if (this.platform.is("android")) {
        // Prompt user about battery optimization using native alert
        this.alertController.create({
          mode: this.platform.is("ios") ? "ios" : "md",
          header: "Alert",
          message:
            "In order to have a better experience, it is recommended " +
            "that you go to the Battery settings and disable battery optimization for GoSpread. " +
            "(Battery > Battery optimization > All apps > GoSpread > Check 'Don't optimize')",
          buttons: [
            "Cancel",
            {
              text: "Open settings",
              handler: () => {
                // Open app settings using a deep link on Android
                Browser.open({ url: "app-settings:" }).catch(() => {});
              },
            },
          ],
        }).then(alert => alert.present());
      }
    }
  }

  private getInfo() {
    if (!this.interval) {
      this.interval = setInterval(async () => {
        const response = <any>(
          await this.crudService
            .getData("motorista/data-termino-fila")
            .toPromise()
        );
        if (response) {
          this.user.dataFimUtilizacao = response;
          localStorage.setItem("user", JSON.stringify(this.user));
        }
      }, 4000);
    }
  }

  ionViewWillLeave() {
    this.clearQueueInterval();
  }

  clearQueueInterval() {
    clearInterval(this.interval);
    this.interval = null;
  }

  async openMessage() {
    await this.util.openModalComment();
  }
  async payPlatform() {
    if (this.balance.saldoEmAberto > 0) {
      await this.router.navigateByUrl("/driver/pay-platform");
    } else {
      await this.util.showToast("No outstanding balance");
    }
  }
  async showLoading() {
    loadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.loadingCtrl.create(loadingProps);
    return await loading.present();
  }

  leaveLine() {
    setTimeout(async () => {
      await this.signalRService.setLeaveLine(this.enterInLineViewModel);
    }, 600);
  }

  async disputedTrips() {
    this.crudService
      .getData(`${environment.useHubV2 ? 'v2/' : ''}Corrida/driver/em-disputa`)
      .subscribe(async (response: any) => {
        console.log(response);
        this.disputedTripsCount = response.length;
      });

    await this.signalRService.getDriverTripsInDispute(async (trip) => {
      this.disputedTripsCount = trip.length;
    });
  }

  async enterQueue() {
    await this.showLoading();
    const connectionStateSub = this.signalRService.connectionState.subscribe({
      next: async (state) => {
        console.log(state);

        const inter = setInterval(async () => {
          if (!this.signalRService.hubConnection) return;
          console.log(this.signalRService.hubConnection.state);
          if (
            this.signalRService.hubConnection.state ===
            HubConnectionState.Connected
          ) {
            const enterQueueRuleResult =
              await this.signalRService.getEnterQueueRuleValidation(
                this.user.id
              );
            console.log(enterQueueRuleResult);
            if (enterQueueRuleResult.canEnterQueue) {
              await this.loadingCtrl.dismiss();
              await this.router.navigate(["driver", "information-queue"]);
              this.isWaiting = !this.isWaiting;
            } else {
              await this.loadingCtrl.dismiss();
              const alert = await this.alertController.create({
                mode: this.platform.is("ios") ? "ios" : "md",
                header: enterQueueRuleResult.type,
                message: enterQueueRuleResult.message,
                buttons: ["Ok"],
              });
              await alert.present();
            }
            connectionStateSub.unsubscribe();
            clearInterval(inter);
          }
        }, 1000);
      },
    });
  }
  private async dismissLoad() {
    if (await this.loadingCtrl.getTop()) {
      await this.loadingCtrl.dismiss();
    }
  }

  async goToScheduledTrips() {
    await this.router.navigate(["call", "scheduled-trips"]);
  }

  private pendingTrip() {
    this.crudService.getData(`${environment.useHubV2 ? 'v2/' : ''}Corrida/corrida-aceita-iniciada`).subscribe(
      async (response: ResponseAPI) => {
        if (response.success) {
          const trip = response.data;
          if (!trip) {
            return;
          }
          localStorage.setItem("currentRace", JSON.stringify(trip));
          const alert = await this.alertController.create({
            keyboardClose: false,
            backdropDismiss: false,
            header: "Pending trip",
            message: `You have a pending trip to ${trip.enderecoDestino}`,
            buttons: [
              {
                text: "Go",
                handler: async () => {
                  await this.router.navigate(
                    trip.statusCorrida === StatusCorrida.ACCEPTED
                      ? ["/driver", "start"]
                      : ["/driver", "current-race"],
                    { relativeTo: this.route, skipLocationChange: true }
                  );
                },
              },
            ],
          });
          await alert.present();
        }
      },
      async (error) => {
        await this.util.showToast(
          "Error retrieving data. Please check your internet connection"
        );
      }
    );
  }
}
